import { FolderCreationPanelAction, FolderCreationPanelActionKeys } from './actions';

interface FolderCreationPanelState {
	isOpen: boolean;
	useSelection: boolean;
	name: string;
}

const initialState: FolderCreationPanelState = {
	isOpen: false,
	useSelection: false,
	name: '',
};

function folderCreationPanel(state: FolderCreationPanelState = initialState, action: FolderCreationPanelAction): FolderCreationPanelState {
	switch (action.type) {
		case FolderCreationPanelActionKeys.OPEN_PANEL:
			return {
				...state,
				isOpen: true,
				useSelection: action.useSelection,
			};
		case FolderCreationPanelActionKeys.CLOSE_PANEL:
			return initialState;
		case FolderCreationPanelActionKeys.SET_NAME:
			return {
				...state,
				name: action.name,
			};
		default:
			return state;
	}
}

export {
	FolderCreationPanelState,
	folderCreationPanel
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/FolderCreationPanel/reducer.ts